import { Controller } from "@hotwired/stimulus"

// Opens a filter dialog by ID. Used on buttons outside the dialog's Stimulus scope.
export default class extends Controller {
  static values = { dialogId: String }

  open(_event) {
    const dialog = document.getElementById(this.dialogIdValue)
    if (dialog) {
      if (dialog.open) {
        dialog.close()
      }
      dialog.showModal()
      document.body.style.overflow = "hidden"
    }
  }
}
